export const CHANGE_USER_CURRENT_ROLE = 'changeUserCurrentRole'
export const PS_VERSIONS = 'psVersions'
export const LOAD_USER = 'loadUser'
